import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useStoreData } from '../hooks/useStoreData';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { heroSlides } = useStoreData();

  useEffect(() => {
    if (heroSlides.length === 0) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroSlides]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  if (heroSlides.length === 0) {
    return (
      <div className="relative h-[600px] bg-[#4a1a1f] overflow-hidden flex items-center justify-center">
        <p className="text-white">Loading...</p>
      </div>
    );
  }

  return (
    <div className="relative h-[600px] bg-[#4a1a1f] overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, #c9a86a 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
      </div>

      {/* Slide Content */}
      <div className="relative h-full flex items-center justify-center text-center px-4">
        <div className="max-w-4xl mx-auto z-10">
          <div className="text-xs uppercase tracking-widest text-[#c9a86a] mb-4 animate-fade-in">
            {heroSlides[currentSlide].description}
          </div>
          <h1 className="text-6xl md:text-8xl font-bold text-[#c9a86a] mb-6 tracking-wider animate-slide-up">
            {heroSlides[currentSlide].title}
          </h1>
          <div className="text-4xl md:text-6xl font-serif italic text-white mb-8 animate-slide-up" style={{ animationDelay: '0.2s' }}>
            {heroSlides[currentSlide].subtitle}
          </div>
          <button className="bg-[#c9a86a] text-[#4a1a1f] px-8 py-3 rounded text-sm uppercase tracking-wider font-semibold hover:bg-white transition-all duration-300 transform hover:scale-105 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            Shop Now
          </button>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 backdrop-blur-sm p-3 rounded-full transition-all duration-300"
      >
        <ChevronLeft className="text-white" size={24} />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 backdrop-blur-sm p-3 rounded-full transition-all duration-300"
      >
        <ChevronRight className="text-white" size={24} />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'w-8 bg-[#c9a86a]' : 'w-2 bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSection;